'use client';

import * as React from 'react';
import { Moon, Sun, Monitor } from 'lucide-react';
import { useTheme } from 'next-themes';
import { Button } from '@/components/ui/button';

interface ThemeSwitcherProps {
  variant?: 'icon' | 'menu';
}

export function ThemeSwitcher({ variant = 'icon' }: ThemeSwitcherProps) {
  const { theme, setTheme } = useTheme();
  const [mounted, setMounted] = React.useState(false);

  React.useEffect(() => {
    setMounted(true);
  }, []);

  if (!mounted) {
    return variant === 'icon' ? (
      <Button variant="ghost" size="icon">
        <Sun className="h-5 w-5" />
      </Button>
    ) : (
      <div className="flex items-center gap-2">
        <Sun className="w-4 h-4" />
        <span>Theme</span>
      </div>
    );
  }

  const toggleTheme = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('system');
    } else {
      setTheme('light');
    }
  };

  const getThemeIcon = () => {
    if (theme === 'dark') return <Moon className="w-4 h-4" />;
    if (theme === 'light') return <Sun className="w-4 h-4" />;
    return <Monitor className="w-4 h-4" />;
  };

  const getThemeLabel = () => {
    if (theme === 'dark') return 'Sombre';
    if (theme === 'light') return 'Clair';
    return 'Système';
  };

  if (variant === 'menu') {
    return (
      <div onClick={toggleTheme} className="flex items-center gap-2 w-full cursor-pointer">
        {getThemeIcon()}
        <span>Thème : {getThemeLabel()}</span>
      </div>
    );
  }

  return (
    <Button
      variant="ghost"
      size="icon"
      onClick={toggleTheme}
      title={`Thème actuel : ${getThemeLabel()}`}
    >
      {theme === 'dark' ? (
        <Moon className="h-5 w-5" />
      ) : (
        <Sun className="h-5 w-5" />
      )}
    </Button>
  );
}
